"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderTrackMixin = exports.SliderThumbMixin = exports.SliderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _SliderLabel = require("../../components/SliderLabel/SliderLabel.styles");
/** @class SliderTrackMixin */
/** @method */
var SliderTrackMixin = function SliderTrackMixin(props) {
  var trackState = props.trackState;
  return (0, _styledToken.default)({
    backgroundColor: 'Slider.trackBackgroundColor',
    backgroundColorSelected: 'Slider.trackBackgroundColorSelected',
    borderRadius: 'Slider.trackBorderRadius',
    trackHeight: 'Slider.trackHeight'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      backgroundColorSelected = _ref.backgroundColorSelected,
      borderRadius = _ref.borderRadius,
      trackHeight = _ref.trackHeight;
    var background = backgroundColor;
    var height = trackHeight;
    if (trackState) {
      if (Array.isArray(trackState.value) && trackState.index === 1 || !Array.isArray(trackState.value) && trackState.index === 0) {
        background = backgroundColorSelected;
      }
    }
    return (0, _styledComponents.css)(["top:calc(50% - ", "px);height:", "px;background:", ";border-radius:", ";cursor:pointer;"], height / 2, height, background, borderRadius);
  })(props);
};

/** @class SliderThumbMixin */
/** @method */
exports.SliderTrackMixin = SliderTrackMixin;
var SliderThumbMixin = (0, _styledToken.default)({
  backgroundColor: 'Slider.thumbBackgroundColor',
  backgroundColorInteractive: 'Slider.thumbBackgroundColorInteractive',
  borderColor: 'Slider.thumbBorderColor',
  borderRadius: 'Slider.thumbBorderRadius',
  borderWidth: 'Slider.thumbBorderWidth',
  boxShadow: 'Slider.thumbBoxShadow',
  focusBoxShadow: 'Slider.thumbFocusBoxShadow',
  labelOffset: 'Slider.thumbLabelOffset',
  size: 'Slider.thumbSize'
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    backgroundColorInteractive = _ref2.backgroundColorInteractive,
    borderColor = _ref2.borderColor,
    borderRadius = _ref2.borderRadius,
    borderWidth = _ref2.borderWidth,
    boxShadow = _ref2.boxShadow,
    focusBoxShadow = _ref2.focusBoxShadow,
    labelOffset = _ref2.labelOffset,
    size = _ref2.size;
  return (0, _styledComponents.css)(["box-sizing:border-box;border:", "px solid ", ";height:", "px;width:", "px;border-radius:", ";box-shadow:", ";background:", ";cursor:grab;&:hover,&:active{background-color:", ";}&:focus{outline:none;box-shadow:", ";}position:relative;display:flex;justify-content:center;&:focus{", "{display:inline-flex;}}", "{display:none;position:absolute;top:", "px;}"], borderWidth, borderColor, size, size, borderRadius, boxShadow, backgroundColor, backgroundColorInteractive, focusBoxShadow, _SliderLabel.StyledSliderLabel, _SliderLabel.StyledSliderLabel, labelOffset);
});

/** @class SliderMixin */
/** @method */
exports.SliderThumbMixin = SliderThumbMixin;
var SliderMixin = (0, _styledToken.default)('Slider.thumbSize', function (size) {
  return "\n        width: 100%;\n        height: " + (size || '') + "px;\n    ";
});
exports.SliderMixin = SliderMixin;